import { ForwardingBatchItemType } from '@ukpostbox/client-data/lib/Types/ForwardingBatchTypes';
import {
	Badge,
	Colour,
	ItemRow,
	ItemRowCell,
	ItemRowSize,
	Pill,
	PillSize,
	Placement,
	StackVertical,
	useLayout,
} from '@ukpostbox/frontend-framework';
import { FormatLocaleDateTime } from '@ukpostbox/helpers';
import { memo } from 'react';
import { ForwardingBatchContents } from './Controls/ForwardingBatchItemContents';

const ForwardingBatchItem = memo((props: ForwardingBatchItemType) => {
	const { isTiny, isSmall, isMedium, isLarge } = useLayout();

	const statusColour =
		props.statusDescription === 'Forwarded'
			? Colour.Success
			: props.statusDescription === 'Pending'
				? Colour.Warning
				: Colour.Alert;

	return (
		<ItemRow
			title={`Forward Batch Entry ${props.batchId}`}
			size={ItemRowSize.Large}
			highlighted={statusColour === Colour.Alert}
			muted={statusColour !== Colour.Alert}
			extraClass='forwarding-batches-item-row'
			extraProps={{
				draggable: false,
			}}
			actionLink={{ url: `/mail/forwarding-batches/${props.batchId}` }}
		>
			<ItemRowCell extraClass='mail-item-thumbs'>
				{props.files.map((file, index) => (
					<ForwardingBatchContents {...file} />
				))}
				<Badge placement={Placement.TopRight} value={props.itemsInBatch} />
			</ItemRowCell>

			<ItemRowCell extraClass='mail-item-reference'>
				<StackVertical>
					<span className='mail-item-tracking-id'>{props.batchIdNo}</span>
					{isTiny && <Pill content={props.statusDescription} colour={statusColour} size={PillSize.Small} />}
				</StackVertical>
			</ItemRowCell>

			{!isTiny && (
				<ItemRowCell>
					<Pill content={props.statusDescription} colour={statusColour} size={PillSize.Small} />
				</ItemRowCell>
			)}

			<ItemRowCell>{props.lastChanged ? FormatLocaleDateTime(props.lastChanged) : ''}</ItemRowCell>

			{!isTiny && !isSmall && (
				<ItemRowCell extraClass='mail-item-pages'>{props.forwardingAddress.formatted}</ItemRowCell>
			)}

			{!isTiny && !isSmall && !isMedium && (
				<ItemRowCell extraClass='mail-item-tags'>{props.postageOption}</ItemRowCell>
			)}

			{!isTiny && !isSmall && !isMedium && !isLarge && (
				<ItemRowCell extraClass='mail-item-tracking-numbers'>
					{props.trackingNumber && <div>{props.trackingNumber}</div>}
				</ItemRowCell>
			)}
		</ItemRow>
	);
});

export default ForwardingBatchItem;
